/**
 * SHUTTERS (2026-10-04) — kernel side: the firm materials a shutter is built in when none
 * is picked. Params: window schema "Shutters" group; geometry: bim-geometry
 * categories/wall/shutters.ts.
 */
export const SHUTTER_MATERIAL_NAMES = {
  leaf: 'Painted Shutter',
  // MATERIAL CLEANUP (2026-10-05): the duplicate 'Black Hardware' merged into this one
  hardware: 'Hardware - Matte Black',
} as const
